import React, { ReactNode } from 'react';
import SimpleHeader from '../Navbar/SimpleHeader';

interface LayoutProps {
  children: ReactNode;
  heading: ReactNode;
}

const SimpleLayout: React.FC<LayoutProps> = ({ children, heading }) => {

  return (
    <div className="flex flex-col h-screen">
      {/* Main Content Area */}
      <div className="flex flex-col flex-grow">
        {/* Header */}
        <SimpleHeader renderHeading={heading} />

        {/* Main Content */}
        <main className="flex-grow bg-gray-100">
          {children}
        </main>
      </div>
    </div>
  );
};

export default SimpleLayout;